import React, { useEffect, useState, useRef, forwardRef } from "react";
import ProfileSection from "./components/ProfileSection";
import LedgerSearchDropdown from "./components/LedgerSearchDropdown";
import { headerConfig } from "./headerConfig";
import "../../../business-types/laundry/modules/home/Home.css";
import { useLedgerSearch } from "./hooks/useLedgerSearch";
import { useUser } from "src/business-types/grocery/components/UserContext";
import { useUserTheme } from "src/shared/utils/useUserTheme";
import Image from "src/shared/Image";

interface HeaderProps {
  Header: string;
}

const Header = forwardRef<HTMLDivElement, HeaderProps>(({ Header }, ref) => {
  const [profileName, setProfileName] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [searchClicked, setSearchClicked] = useState(false);
  const [, setOrganizationName] = useState("");
  const [username, setUsername] = useState("");
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { searchTerm, results, setSearchTerm } = useLedgerSearch();
  const { user } = useUser();
  const { fontClass, bgClass, borderHighlight } = useUserTheme();

  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username") || "";
    const storedProfileName = sessionStorage.getItem("Profilename") || "";
    setProfileName(user?.name || storedProfileName);
    setBusinessType(sessionStorage.getItem("business_type") || "");
    setUsername(user?.user_name || storedUsername);
    setOrganizationName(sessionStorage.getItem("organization_name") || "Organization Name");
  }, [user]);

  // Header configuration
  const config = headerConfig[businessType] || {
    showSearch: true,
    gridClass: "grid-container",
    titleClass: "text-xl font-bold",
    extraRight: null,
  };

  const windowsLocation = window.location.pathname;

  useEffect(() => {
    setSearchTerm("");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowsLocation]);

  return (
    <header className={`head-name ${bgClass} ${fontClass}`} id="head_name">
      {/* Logo, Organization Name, and Title */}
      <div className="ml-14">
        <div className="brand-flex">
          <div className="logo-header">
            <Image imagePath={user?.image_url} className="logo-container" company={true} />
          </div>
          <div className="org-name-container">
            <h1 className={`org-name titleClass ${fontClass}`}>{user?.organization_name}</h1>
          </div>
          <div className={`pos-title-container titleClass ${fontClass}`}>
          <h2 className={`${config.titleClass} ${fontClass}`}>{Header}</h2>          </div>
        </div>
      </div>

      {/* Right section (search, restaurant orders, profile) */}
      <div
        className={config.gridClass}
        style={{ width: businessType === "Restaurant" ? "640px" : "500px", display: "flex", justifyContent: "space-evenly", alignItems: "center", }} >
        {/* ✅ Hide ledger search if Restaurant */}
        {businessType !== "Restaurant" && config.showSearch && (
          <div className="search_header">
            <input
              name="Ledger search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onFocus={() => setSearchClicked(true)}
              onClick={() => setSearchClicked(true)}
              placeholder="Ledger search by Name or Phone number"
              className={`w-full px-3 py-2.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 ${borderHighlight} ${fontClass} text-sm text-black`}
            />
            {searchClicked && searchTerm.trim() && (
              <div ref={dropdownRef} className="table-container-ledger">
                <LedgerSearchDropdown results={results} onClose={() => setSearchClicked(false)} />
              </div>
            )}
          </div>
        )}

        <div className="flex" style={{ marginLeft: "auto", marginRight: "1rem" }}>
          <ProfileSection profileName={profileName} username={username} />
        </div>
      </div>
    </header>
  );
});

Header.displayName = "Header";
export default Header;
